function initCountdownTimer(el) {
  const targetDate = new Date(el.dataset.target);

  if (Number.isNaN(targetDate.getTime())) return;

  const daysEl = el.querySelector('[data-countdown-days]');
  const hoursEl = el.querySelector('[data-countdown-hours]');
  const minutesEl = el.querySelector('[data-countdown-minutes]');
  const secondsEl = el.querySelector('[data-countdown-seconds]');

  const pad = (value) => String(value).padStart(2, '0');

  let intervalId;

  function update() {
    const diff = targetDate.getTime() - Date.now();

    if (diff <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      el.setAttribute('data-countdown-ended', '');
      clearInterval(intervalId);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    daysEl.textContent = pad(days);
    hoursEl.textContent = pad(hours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  }

  update();
  intervalId = setInterval(update, 1000);
}

document.querySelectorAll('[data-countdown-timer]').forEach(initCountdownTimer);
